import React from "react";

const ListReviews = ({ reviews }) => {
    const list = Array.isArray(reviews) ? reviews : [];
    return (
        <div className="mt-4">
            <div className="card shadow-sm border-0 p-4" style={{ borderRadius: 16 }}>
                <h4 className="mb-3 fw-bold" style={{ color: "#e04f6ecd" }}>Customer Reviews</h4>
                <hr />

                {list.length > 0 ? (
                    list.map((review, index) => (
                        <div key={index} className="py-3 border-bottom">
                            <div className="d-flex align-items-start" style={{ gap: 12, flexWrap: 'wrap' }}>
                                <img
                                    src="/images/default_avatar.jpg"
                                    alt={review.user?.name || "User"}
                                    width="50"
                                    height="50"
                                    style={{ borderRadius: '50%', border: '1px solid #eee', flex: '0 0 auto' }}
                                />
                                <div style={{ flex: 1, minWidth: 200 }}>
                                    <div className="d-flex align-items-center mb-1" style={{ flexWrap: 'wrap' }}>
                                        {[...Array(5)].map((_, i) => (
                                            <i
                                                key={i}
                                                className="fa fa-star"
                                                style={{
                                                    color: i < (review?.rating || 0) ? '#ffb829' : '#c0c4cc',
                                                    marginRight: 4
                                                }}
                                            ></i>
                                        ))}
                                    </div>
                                    <p className="mb-1 fw-semibold" style={{ color: '#333', wordBreak: 'break-word' }}>
                                        {review.user?.name || "Anonymous"}
                                    </p>
                                    <p className="small mb-0" style={{ color: '#666', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                        {review.comment || "No comment provided."}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-muted mt-3">No reviews yet. Be the first to review!</p>
                )}
            </div>
        </div>
    );
};

export default ListReviews;
